import EventHubMixin from '@/mixins/EventHub.js'
import TimeMixin from '@/mixins/Time'
import SizesMixin from '@/mixins/Sizes.js'

export default
{
    name: 'app-content-globe',

    mixins:
    [
        EventHubMixin,
        TimeMixin,
        SizesMixin
    ],

    props:
    {
        shouldLoadThree: { type: Boolean, default: true },
        locations: { type: Array, default: () => [] }
    },

    created()
    {
        console.log(this.locations)
        /* Gestures */
        this.gesture = {
            dragging: false,
            x: 0,
            y: 0,
            previous: {
                x: 0,
                y: 0
            },
            start: {
                x: 0,
                y: 0
            },
            speed: {
                x: 0,
                y: 0
            }
        }

        // Textures
        this.texturesLoaded = []

        this.initialized = false
    },

    mounted()
    {
        // // Get Lat,Lng from Google
        // this._getLocationsGPS(() =>
        // {
        this.$el.addEventListener('touchstart', this._onTouchStart)
        this.$el.addEventListener('mousedown', this._onMousedown)

        if(this.shouldLoadThree)
        {
            // Load THREE only on this page
            const three = document.createElement('script')
            const url = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/96/three.min.js'
            three.setAttribute('src', url)
            document.body.appendChild(three)

            const xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.send(null)

            // Wait for THREE
            xhr.onload = () =>
            {
                window.setTimeout(() =>
                {
                    this._launchTHREE()
                }, 200)
                // this._checkTHREEIndex = 0
                // this._checkTHREE(this._launchTHREE)
            }
        }
        // })

        /* Container */
        this.width = this.$el.offsetWidth
        this.height = this.$el.offsetHeight

        this.$eventHub.$on('globe.canLaunchThree', this._launchTHREE)
    },

    destroyed()
    {
        this.$el.removeEventListener('touchstart', this._onTouchStart)
        this.$eventHub.$off('globe.canLaunchThree', this._launchTHREE)
    },

    methods:
    {
        // EVENTS
        onTick()
        {
            if(this.gesture.dragging)
            {
                const deltaX = this.gesture.x - this.gesture.previous.x
                const deltaY = this.gesture.y - this.gesture.previous.y

                this.gesture.previous.x = this.gesture.x
                this.gesture.previous.y = this.gesture.y

                this.gesture.speed.x = deltaX * 0.005
                this.gesture.speed.y = deltaY * 0.005
            }
            else
            {
                this.gesture.speed.x *= 0.95

                if(Math.abs(this.gesture.speed.x) <= 0.01)
                {
                    this.gesture.speed.x += 0.0001
                }
            }

            if(this.group)
            {
                this.group.rotation.y += this.gesture.speed.x
            }

            if(this.initialized)
            {
                // Update Globe opacity
                if(this.material.opacity < 1)
                {
                    this.material.opacity += (this.materialOpacity - this.material.opacity) * 0.025

                    if(this.material.opacity >= 0.96)
                    {
                        this.material.opacity = 1
                    }
                }

                // Update Points opacity
                if(this.material.opacity >= 0.75
                    && this.pointsMaterial.opacity < 1)
                {
                    this.pointsMaterial.opacity += (this.pointsMaterialOpacity - this.pointsMaterial.opacity) * 0.025

                    if(this.pointsMaterial.opacity >= 0.96)
                    {
                        this.pointsMaterial.opacity = 1
                    }
                }
            }

            if(this.renderer)
            {
                this.renderer.render(this.scene, this.camera)
            }
        },

        onResize()
        {
            this.width = this.$el.offsetWidth
            this.height = this.$el.offsetHeight
            this.renderer.setSize(this.width, this.height)
            this.camera.aspect = this.width / this.height
            this.camera.updateProjectionMatrix()
        },

        // THREE js
        _launchTHREE()
        {
            this.init()
            this.onTick()
        },

        _checkTHREE()
        {
            // Check if THREE is available
            window.requestAnimationFrame(() =>
            {
                this._checkTHREEIndex += 1
                if(typeof THREE === 'undefined')
                {
                    // Check 10 time, then return error
                    if(this._checkTHREEIndex <= 10)
                    {
                        this._checkTHREE(this._launchTHREE.bind(this))
                    }
                    else
                    {
                        console.error('THREE.js can\'t be loaded')
                    }
                }
                else
                {
                    this.$eventHub.$emit('content.threeIsLoaded')
                }
            })
        },

        init()
        {
            this.renderer = new THREE.WebGLRenderer(
                {
                    antialias: true
                }
            )
            this.renderer.setClearColor(0xffffff, 1)

            this.camera = new THREE.PerspectiveCamera(50, this.width / this.height, 0.001, 10)
            this.camera.position.z = 4.75

            this.scene = new THREE.Scene()

            this.group = new THREE.Group()
            this.group.position.x = 0.25
            this.group.rotation.y = 270 * Math.PI / 180
            this.group.rotation.x = 23 * Math.PI / 180
            this.scene.add(this.group)

            // Load Earth's texture
            const loader = new THREE.TextureLoader()
            loader.load('/images/globe-texture.jpg', (texture) =>
            {
                // Create Earth
                this.texturesLoaded.push('/images/globe-texture.jpg')
                this.geometry = new THREE.SphereGeometry(2, 32, 32)
                this.material = new THREE.MeshBasicMaterial({
                    map: texture,
                    transparent: true
                })
                this.materialOpacity = 1
                this.material.opacity = 0

                this.mesh = new THREE.Mesh(this.geometry, this.material)
                this.group.add(this.mesh)

                if(this.locations.length > 0)
                {
                    // Load Points' texture
                    loader.load('/images/globe-point-texture.png', (texture) =>
                    {
                        // Create only 1 geometry & 1 material for all points
                        this.texturesLoaded.push('/images/globe-points-texture.png')
                        this.pointsGeometry = new THREE.PlaneGeometry(0.02, 0.02, 1, 1)
                        this.pointsMaterial = new THREE.MeshBasicMaterial({
                            map: texture,
                            transparent: true,
                            side: THREE.BackSide
                        })
                        this.pointsMaterialOpacity = 1
                        this.pointsMaterial.opacity = 0

                        // Create 1 mesh for 1 point
                        for(let i = 0; i < this.locations.length; i += 1)
                        {
                            const location = this.locations[i]
                            location.mesh = new THREE.Mesh(this.pointsGeometry, this.pointsMaterial)
                            location.mesh.scale.set(location.size, location.size, 1)

                            // Get XYZ coordinate from lat,lng
                            const{ x, y, z } = this._convertLatLngToXYZ({
                                lat: parseFloat(location.lat),
                                lng: parseFloat(location.lon)
                            })

                            location.mesh.position.x = x
                            location.mesh.position.y = y
                            location.mesh.position.z = z

                            location.mesh.lookAt(this.mesh.position)

                            this.group.add(location.mesh)
                        }

                        this.initialized = true
                    })
                }
            })

            this.renderer.setSize(this.width, this.height)
            this.$el.appendChild(this.renderer.domElement)
        },

        _convertLatLngToXYZ({ lat, lng })
        {
            const phi   = (90 - lat) * (Math.PI / 180)
            const theta = (lng + 180) * (Math.PI / 180)
            const radius = 2

            const x = -((radius) * Math.sin(phi) * Math.cos(theta))
            const z = ((radius) * Math.sin(phi) * Math.sin(theta))
            const y = ((radius) * Math.cos(phi))

            return { x, y, z }
        },

        // MOUSE EVENTS
        _onMousedown(event)
        {
            this.gesture.dragging = true
            this.$el.classList.add('is-grabbing')

            this.gesture.previous.x = event.clientX
            this.gesture.previous.y = event.clientY

            this.gesture.start.x = this.gesture.previous.x
            this.gesture.start.y = this.gesture.previous.y

            this.gesture.x = this.gesture.start.x
            this.gesture.y = this.gesture.start.y

            this.$el.addEventListener('mousemove', this._onMousemove)
            window.addEventListener('mouseup', this._onMouseup)
        },

        _onMousemove(event)
        {
            if(!this.gesture.dragging)
            {
                return
            }

            if(Math.abs(this.gesture.start.y - event.clientY) < 50)
            {
                event.preventDefault()
                this.gesture.x = event.clientX
                this.gesture.y = event.clientY
            }
        },

        _onMouseup()
        {
            if(!this.gesture.dragging)
            {
                return
            }

            this.gesture.dragging = false
            this.$el.classList.remove('is-grabbing')

            this.$el.removeEventListener('mousemove', this._onMousemove)
            window.removeEventListener('mouseup', this._onMouseup)
        },

        // TOUCH EVENTS
        _onTouchStart(event)
        {
            this.gesture.dragging = true
            this.$el.classList.add('is-grabbing')

            this.gesture.previous.x = event.touches[0].clientX
            this.gesture.previous.y = event.touches[0].clientY

            this.gesture.start.x = this.gesture.previous.x
            this.gesture.start.y = this.gesture.previous.y

            this.gesture.x = this.gesture.start.x
            this.gesture.y = this.gesture.start.y

            this.$el.addEventListener('touchmove', this._onTouchMove)
        },

        _onTouchMove(event)
        {
            if(!this.gesture.dragging) return

            if(Math.abs(this.gesture.start.y - event.touches[0].clientY) < 50)
            {
                event.preventDefault()
                this.gesture.x = event.touches[0].clientX
                this.gesture.y = event.touches[0].clientY
            }

            this.$el.addEventListener('touchend', this._onTouchEnd)
        },

        _onTouchEnd()
        {
            if(!this.gesture.dragging)
            {
                return
            }

            this.gesture.dragging = false
            this.$el.classList.remove('is-grabbing')

            this.$el.removeEventListener('touchmove', this._onTouchMove)
            this.$el.removeEventListener('touchend', this._onTouchEnd)
        },

        // GETTERS
        _getLocationsGPS(callback)
        {
            let locationsGot = 0
            if(this.locations.length > 0)
            {
                // Get Lat,Lng coordinates for each points w/ G.Maps API
                for(let i = 0; i < this.locations.length; i += 1)
                {
                    const search = encodeURI(this.locations[i].search)
                    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${search}&key=AIzaSyDHO7nePG33zzMxy75I7X7-x-Qlioscdlw`

                    const xhr = new XMLHttpRequest()
                    xhr.open('GET', url, true)
                    xhr.send(null)

                    xhr.onload = () =>
                    {
                        const response = JSON.parse(xhr.responseText)

                        const res = response.results[0]
                        const location = res.geometry.location
                        this.locations[i].location = location

                        locationsGot += 1

                        if(locationsGot === this.locations.length)
                        {
                            callback()
                        }
                    }
                }
            }
            else
            {
                callback()
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-content-globe/script.js